import * as React from "react";
import type { SVGProps } from "react";
const SvgServingFoodWithClocheSlashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.293 2.293a1 1 0 0 1 1.414 0l18.068 18.075a1 1 0 0 1-1.407 1.407l-1.379-1.372-1.999 1.177c-.46.27-.99.41-1.52.41h-5.13c-.32 0-.64-.05-.95-.15l-1.45-.48c-.15.37-.51.64-.93.64h-3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v.13l.94-.63c.49-.33 1.07-.5 1.66-.5h1.976l-1-1H3c-.55 0-1-.45-1-1s.45-1 1-1h1.07a7.95 7.95 0 0 1 1.617-3.898L2.294 3.707a1 1 0 0 1 0-1.414M5 20h1v-4H5zm5.6-4c-.2 0-.39.06-.56.17l-2.05 1.37v1.74l2.01.67c.11.03.21.05.32.05h5.13c.18 0 .36-.05.51-.14h-.01l1.573-.924-.937-.936H13.99c-.55 0-1-.45-1-1s.45-1 1-1zM7.116 8.53A6 6 0 0 0 6.09 11h3.496z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.16 16c.86 0 1.61.53 1.89 1.34.15.437.146.89.006 1.302L18.414 16zM12 2c.55 0 1 .45 1 1v1.07c3.61.45 6.48 3.32 6.93 6.93H21c.55 0 1 .45 1 1s-.45 1-1 1h-5.586l-2-2h4.496c-.48-2.83-2.94-5-5.91-5-1.036 0-2.01.264-2.858.728L7.687 5.272A7.9 7.9 0 0 1 11 4.07V3c0-.55.45-1 1-1"
    />
  </svg>
);
export default SvgServingFoodWithClocheSlashed;
